// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {SimUser} from "@models";
import {NotificationService, SimUserExtendedService, CustomValidationService} from "@services";
import {Translations} from "@translations";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";

export interface DialogData_ChangePasswordDialogInput extends MatDialogDataBaseInput {
	userForPasswordChange: SimUser;
}

export interface DialogData_ChangePasswordDialogOutput extends MatDialogDataBaseOutput {}

@Component({
	selector: "sim-change-user-password-dialog",
	templateUrl: "./change-user-password-dialog.component.html",
	styleUrls: ["./change-user-password-dialog.component.scss"],
	animations: [zoomOutOnLeaveAnimation({duration: 175}), zoomInOnEnterAnimation({duration: 175})],
	standalone: false,
})
export class ChangeUserPasswordDialogComponent extends BasicMaterialDialog<
	ChangeUserPasswordDialogComponent,
	DialogData_ChangePasswordDialogInput,
	DialogData_ChangePasswordDialogOutput
> {
	T = Translations;

	public loggedInUser: SimUser;
	verifyPasswordFormControl = new FormControl("", [Validators.required]);
	enablePasswordChange: boolean = false;

	hidePasswordUnlock: boolean = true;
	hidePasswordNew: boolean = true;

	newPasswordFormGroup: FormGroup<{
		password: FormControl<string>;
		confirmPassword: FormControl<string>;
	}>;

	constructor(
		_injector: Injector,
		private _simUserService: SimUserExtendedService,
		private _simNotificationService: NotificationService,
		private _customValidationService: CustomValidationService,
		fb: FormBuilder,
	) {
		super(_injector);

		this.newPasswordFormGroup = fb.group(
			{
				password: ["", [Validators.required, this._customValidationService.passwordValidator()]],
				confirmPassword: [""],
			},
			{
				validators: this._customValidationService.matchPassword("password", "confirmPassword"),
			},
		);

		this.loggedInUser = _simUserService.user;
	}

	ngOnInit(): void {}

	verifyPasswordOfCurrentUser() {
		this._simUserService
			.loginForPWChange({
				checkOnly: true,
				loginUrl: "",
				password: this.verifyPasswordFormControl.value,
				usernameOrEmail: this.loggedInUser.username,
			})
			.then(
				(res) => {
					this.enablePasswordChange = true;
					this._simNotificationService.notifySuccess("Password check was successfull");
				},
				(err) => {
					this.verifyPasswordFormControl.setErrors({
						backendLoginError: true,
					});
				},
			);
	}

	updateUserPassword() {
		this._simUserService
			.changePassword({
				user: this.data.userForPasswordChange,
				password: this.newPasswordFormGroup.value.password,
			})
			.then(() => {
				this._simNotificationService.notifySuccess("Password successfully changed");
				this.close({action: "ok"});
			});
	}
}
